// extracted by mini-css-extract-plugin
export default {"blacklistSwitch":"BlacklistSwitchButton_blacklistSwitch__1Tt01"};